import { render } from "./RenderQcm.vue?vue&type=template&id=6501f424"
import script from "./RenderQcm.vue?vue&type=script&lang=js"
export * from "./RenderQcm.vue?vue&type=script&lang=js"

import "./RenderQcm.vue?vue&type=style&index=0&id=6501f424&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__